export { getPronoun, PronounType } from './getPronoun';
export type { Gender } from './getPronoun';
export { getPronounByPetGenders } from './getPronounByPetGenders';
